//
//
//
//
//
//

export default {
  data() {
    return {
      isVisible: false
    }
  },
  computed: {

  },
  mounted() {
    //check if user has scrolled a certain distance (this option is more closer to the ticket request)
     if(this.$device.isMobile) {
        window.onscroll = (ev)=> {
          this.isVisible = window.scrollY >= 300;
       };
     } else {
        document.getElementById('main_body').addEventListener('scroll', (ev)=> {
          this.isVisible = document.getElementById('main_body').scrollTop >= 300;
        })
     }
  },
  methods: {
    scrollToTop() {
      if(this.$device.isMobile) {
        window.scroll({ top: 0, behavior: 'smooth' })
      } else {
        document.getElementById('main_body').scroll({ top: 0, behavior: 'smooth' })
      }
    }
  }
}
